import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import api, { rupee } from "@/lib/api";
import CustomerLayout from "@/components/CustomerLayout";
import { SkeletonCard, EmptyState } from "@/components/States";
import { Package, ChevronRight } from "lucide-react";

const STATUS_LABEL = {
  placed: "Order placed", accepted: "Accepted", preparing: "Preparing", ready: "Ready",
  assigned: "Rider assigned", picked_up: "Picked up", out_for_delivery: "Out for delivery",
  delivered: "Delivered", cancelled: "Cancelled",
};
const STATUS_COLOR = (s) => s === "delivered" ? "bg-brand-soft text-brand" : s === "cancelled" ? "bg-red-50 text-red-500" : "bg-amber-soft text-amber-warm";

export default function Orders() {
  const nav = useNavigate();
  const { data: orders, isLoading } = useQuery({ queryKey: ["orders"], queryFn: () => api.get("/orders").then((r) => r.data) });

  return (
    <CustomerLayout>
      <h1 className="mb-5 font-head text-2xl font-extrabold text-slate-900 sm:text-3xl">Your orders</h1>
      {isLoading ? <div className="space-y-3">{Array.from({ length: 3 }).map((_, i) => <SkeletonCard key={i} />)}</div>
        : orders?.length ? (
          <div className="space-y-3">
            {orders.map((o) => (
              <button key={o.id} data-testid="order-row" onClick={() => nav(`/order/${o.id}`)}
                className="flex w-full items-center gap-4 rounded-2xl border border-slate-200 bg-white p-4 text-left transition-all hover:border-brand/40 hover:shadow-md">
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-soft text-brand"><Package className="h-6 w-6" /></div>
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <p className="font-head font-bold text-slate-900">#{o.order_no}</p>
                    <span data-testid="order-status-badge" className={`rounded-md px-2 py-0.5 text-[11px] font-bold ${STATUS_COLOR(o.status)}`}>{STATUS_LABEL[o.status]}</span>
                  </div>
                  <p className="text-sm text-slate-500">{o.store_name} · {o.items.length} items</p>
                  <p className="text-xs text-slate-400">{new Date(o.created_at).toLocaleString("en-IN")}</p>
                </div>
                <div className="text-right">
                  <p className="font-mono font-bold text-slate-900">{rupee(o.total)}</p>
                  <ChevronRight className="ml-auto h-5 w-5 text-slate-300" />
                </div>
              </button>
            ))}
          </div>
        ) : <EmptyState icon={Package} title="No orders yet" subtitle="Your orders will appear here." action={<button onClick={() => nav("/stores")} className="mt-4 rounded-xl bg-brand px-5 py-2.5 text-sm font-bold text-white">Start shopping</button>} />}
    </CustomerLayout>
  );
}
